import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { CDN_TYPE_SPORT, getCDNUrl } from 'utils';

import { useArchivedCategoryState } from '@atlas/core';
import { Flag, Icon } from '@atlas/ui';

import ResultsTournamentItem from './ResultsTournamentItem';

const ResultsTournaments = ({ forceIsExpanded }) => {
  const [isExpanded, setIsExpanded] = useState(forceIsExpanded);
  const category = useArchivedCategoryState();

  const { imagePaths, name, regionId, tournaments } = category;
  const imagePath = imagePaths?.FLAG;

  const toggleExpanded = useCallback(() => {
    setIsExpanded(isExpanded => !isExpanded);
  }, [setIsExpanded]);

  const arrowClassName = cx({ down: !isExpanded, up: isExpanded });

  const iconArrowClassName = cx(`arrow-${arrowClassName}`);

  const menuItemClassName = cx('menu-item-container sport', { active: isExpanded });

  return (
    <div className="category-table-container">
      <div className={menuItemClassName}>
        <div className="menu-item-icon">
          <Flag
            alt={name}
            cdnHostname={getCDNUrl(CDN_TYPE_SPORT)}
            className="lang-flag"
            height={16}
            imagePath={imagePath}
            name={regionId}
            width={20}
          />
        </div>
        <div className="menu-item-text" onClick={toggleExpanded}>
          <h2 className="main-label">{category.name}</h2>
        </div>
        <div className="menu-item-icon-controls">
          <div className="font-icon-container">
            <Icon name={iconArrowClassName} onClick={toggleExpanded} />
          </div>
        </div>
      </div>
      {isExpanded && (
        <div className="tournament-table">
          {tournaments.map((tournament, i) => (
            <ResultsTournamentItem
              forceIsExpanded={i === 0}
              key={tournament.id}
              tournament={tournament}
            />
          ))}
        </div>
      )}
    </div>
  );
};

ResultsTournaments.propTypes = {
  forceIsExpanded: PropTypes.bool.isRequired,
  isHeaderActive: PropTypes.bool,
  setHeaderActive: PropTypes.func,
};

export default ResultsTournaments;
